import {
  START_LOAD_PLAN_ENTRIES,
  LOAD_PLAN_ENTRIES_SUCCESS,
  LAYOUT_CHANGE,
  ADD_FILTER,
  REMOVE_FILTER,
  CHANGE_ORDER,
  SET_INITIAL_FILTERS,
  CLEAR_FILTER,
  CHANGE_FILTER_URL,
  CLEAR_ALL_FILTERS,
  CLEAR_PLAN_ENTRIES,
  DEFAULT_FILTERS,
  ADD_CUSTOM_DURATION_FILTER
} from '../../actions/planEntries'

const defaultState = {
  grid: {
    isLoading: true,
    page: 1,
    layout: 'tile'
  },
  customDuration: {
    min: null,
    max: null
  },
  filtered: {
    instructors: [],
    styles: {},
    difficulties: [],
    intensities: [],
    focus_area: [],
    equipment: [],
    excludeCompleted: false,
    duration: []
  }
}

let planEntries = (state = defaultState, action) => {
  let newGridState
  switch (action.type) {
    case CLEAR_PLAN_ENTRIES:
      newGridState = state.grid
      newGridState.page = 1
      newGridState.isInitialLoad = true
      return Object.assign({}, state, {
        grid: newGridState
      })
    case START_LOAD_PLAN_ENTRIES:
      return Object.assign({}, state, {
        grid: {
          ...state.grid,
          isLoading: true
        }
      })
    case LAYOUT_CHANGE:
      return Object.assign({}, state, {
        grid: {
          ...state.grid,
          layout: action.layout
        }
      })
    case DEFAULT_FILTERS:
      return { ...state, defaultFilter: action.defaultFilter }
    case CLEAR_ALL_FILTERS:
      return Object.assign({}, state, {
        filtered: {
          instructors: [],
          styles: [],
          yoga: [],
          fitness: [],
          mindfulness: [],
          wellness: [],
          skills: [],
          difficulties: [],
          intensities: [],
          excludeCompleted: false,
          focus_area: [],
          equipment: [],
          duration: []
        }
      })
    case CLEAR_FILTER:
      if (action.label === 'duration') {
        return Object.assign({}, state, {
          filtered: {
            ...state.filtered,
            duration: []
          }
        })
      } else {
        return Object.assign({}, state, {
          filtered: {
            ...state.filtered,
            [action.label]: []
          }
        })
      }

    case CHANGE_ORDER:
      return Object.assign({}, state, {
        order: action.order
      })
    case SET_INITIAL_FILTERS:
      return Object.assign({}, state, {
        filtered: action.initialFilters
      })

    case ADD_CUSTOM_DURATION_FILTER:
      return Object.assign({}, state, {
        customDuration: {
          min: parseInt(action.min) || 0,
          max: parseInt(action.max) || null
        }
      })
    case ADD_FILTER:
      switch (action.filterSection) {
        case 'duration':
        case 'custom_duration':
          let currentDurationFilters = state.filtered['duration'] || []
          if (action.filterSection === 'custom_duration') {
            currentDurationFilters = currentDurationFilters.reduce(
              (acc, duration) => {
                if (action.filter.preDefinedDurations.includes(duration)) {
                  return [duration, ...acc]
                } else {
                  return [...acc]
                }
              },
              []
            )
          }
          const time = `${action.filter.min}-${action.filter.max}`
          if (!currentDurationFilters?.includes(time)) {
            currentDurationFilters = [...currentDurationFilters,time ]
          }
          return Object.assign({}, state, {
            filtered: {
              ...state.filtered,
              ['duration']: currentDurationFilters
            }
          })
        case 'styles':
          const {
            filter,
            options: { isRoot, root }
          } = action
          const categoryFilters = state.filtered.styles

          let filteredSubcategories
          if (isRoot) {
            filteredSubcategories = 'all'
          } else {
            filteredSubcategories =
              !categoryFilters[root.slug] ||
              categoryFilters[root.slug].filteredSubcategories === 'all'
                ? []
                : categoryFilters[root.slug].filteredSubcategories

            filteredSubcategories.push(filter)
          }
          return Object.assign({}, state, {
            filtered: {
              ...state.filtered,
              styles: {
                ...categoryFilters,
                [root.slug]: {
                  ...root,
                  filteredSubcategories
                }
              }
            }
          })
        case 'yoga':
        case 'fitness':
        case 'mindfulness':
        case 'wellness':
        case 'skills':
          let currentCategoryFilters =
            state.filtered[action.filterSection] || []
          if (
            action.filter.slug === action.filterSection ||
            (action.filter.slug !== action.filterSection &&
              currentCategoryFilters.some(
                (item) => item.slug === action.filterSection
              ))
          ) {
            currentCategoryFilters = []
          }
          currentCategoryFilters = [...currentCategoryFilters,action.filter]
          return Object.assign({}, state, {
            filtered: {
              ...state.filtered,
              [`${action.filterSection}`]: currentCategoryFilters
            }
          })
        case 'excludeCompleted':
          return Object.assign({}, state, {
            filtered: {
              ...state.filtered,
              excludeCompleted: true
            }
          })
        default:
          let currentFilters = state.filtered[action.filterSection] || []
          let updatedFilters = [...currentFilters, action.filter]
          return Object.assign({}, state, {
            filtered: {
              ...state.filtered,
              [`${action.filterSection}`]: updatedFilters
            }
          })
      }

    case REMOVE_FILTER:
      switch (action.filterSection) {
        case 'duration':
          let currentDurationFilters =
            state.filtered[action.filterSection] || []
          const updatedDuration = currentDurationFilters.filter(
            (duration) => duration !== action.filter
          )
          return Object.assign({}, state, {
            filtered: {
              ...state.filtered,
              [`${action.filterSection}`]: updatedDuration
            }
          })
        case 'styles':
          const {
            filter,
            options: { isRoot, rootSlug }
          } = action
          let categoryFilters = state.filtered.styles

          if (isRoot) {
            delete categoryFilters[filter]
          } else {
            const filteredSubcategories = categoryFilters[
              rootSlug
            ].filteredSubcategories.filter(
              (subcategory) => subcategory.slug !== filter
            )
            if (filteredSubcategories.length === 0) {
              delete categoryFilters[rootSlug]
            } else {
              categoryFilters[rootSlug].filteredSubcategories =
                filteredSubcategories
            }
          }

          return Object.assign({}, state, {
            filtered: {
              ...state.filtered,
              styles: {
                ...categoryFilters
              }
            }
          })
        case 'excludeCompleted':
          return Object.assign({}, state, {
            filtered: {
              ...state.filtered,
              excludeCompleted: false
            }
          })
        default:
          const newFilters = state.filtered[action.filterSection].filter(
            (item) => {
              if (typeof item === 'object') {
                return item[action.filterByField] !== action.filter
              } else {
                return item !== action.filter
              }
            }
          )
          return Object.assign({}, state, {
            filtered: {
              ...state.filtered,
              [`${action.filterSection}`]: newFilters
            }
          })
      }
    case LOAD_PLAN_ENTRIES_SUCCESS:
      return Object.assign({}, state, {
        grid: {
          ...state.grid,
          isLoading: false,
          isInitialLoad: false,
          total: action.totalPlanEntries,
          page: state.grid.page + 1
        }
      })
    case CHANGE_FILTER_URL:
      let newUrl = ''
      const filters = action.filters
      for (const filterSection in filters) {
        const filteredAttributes = filters[filterSection]
        if (filterSection === 'min' && filters.min) {
          newUrl += `min=${filters.min}&`
        } else if (filterSection === 'max' && filters.max) {
          newUrl += `max=${filters.max}&`
        } else if (filterSection === 'order') {
          newUrl += `${filterSection}=${filteredAttributes}&`
        } else if (filterSection === 'excludeCompleted' && filteredAttributes) {
          newUrl += `${filterSection}=${filteredAttributes}&`
        } else if (filteredAttributes && filteredAttributes.length > 0) {
          newUrl += `${filterSection}=${filteredAttributes.join()}&`
        }
      }
      return Object.assign({}, state, {
        filterUrl: newUrl
      })
    default:
      return state
  }
}

export default planEntries
